import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/why-choose-us', label: 'Why Choose Us' },
    { path: '/situations', label: 'Situations' },
    { path: '/about', label: 'About' },
    { path: '/reviews', label: 'Reviews' },
    { path: '/faq', label: 'FAQ' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/3c52382db3d8225592af0a3213452f44.png"
              alt="Infinity Investment Property Solutions"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-all duration-300 hover:text-[#C9A961] relative cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#C9A961]'
                    : isScrolled
                    ? 'text-[#1A1A1A]'
                    : 'text-[#1A1A1A]'
                }`}
              >
                {link.label}
                {location.pathname === link.path && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#C9A961]"></span>
                )}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+12695551234"
              className={`flex items-center gap-2 font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-[#1A1A1A]' : 'text-[#1A1A1A]'
              }`}
            >
              <i className="ri-phone-line text-[#C9A961]"></i>
              (269) 555-1234
            </a>
            <Link
              to="/contact"
              className="px-6 py-3 bg-[#C9A961] text-white font-semibold rounded-lg hover:bg-[#B8954E] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get My Offer
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i
              className={`${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-2xl text-[#1A1A1A]`}
            ></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-[#D4C5B9]">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-base font-medium py-2 transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#C9A961] border-l-2 border-[#C9A961] pl-4'
                    : 'text-[#1A1A1A] pl-4'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 border-t border-[#D4C5B9] space-y-3">
              <a
                href="tel:+12695551234"
                className="flex items-center gap-2 text-[#1A1A1A] font-medium pl-4 cursor-pointer"
              >
                <i className="ri-phone-line text-[#C9A961]"></i>
                (269) 555-1234
              </a>
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-6 py-3 bg-[#C9A961] text-white font-semibold rounded-lg text-center cursor-pointer"
              >
                Get My Offer
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}